import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    dailyViewUrl: String
  }

  connect() {
    this.checkAndRedirect()
    this.setupResizeListener()
  }

  disconnect() {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }
  }

  setupResizeListener() {
    window.addEventListener('resize', this.handleResize.bind(this))
  }

  handleResize() {
    clearTimeout(this.resizeTimeout)
    this.resizeTimeout = setTimeout(() => {
      this.checkAndRedirect()
    }, 250)
  }

  checkAndRedirect() {
    if (this.isMobile()) {
      window.location.href = this.dailyViewUrlValue
    }
  }

  isMobile() {
    return window.innerWidth <= 768 || /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }
}
